<template>
  <div id="scroll-target"></div>
</template>

<script>
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx

export default {
  components: {},
  data: () => ({
    order_id: null,
    showPagination: false,
    isBusy: false,
    currentPage: 1,
    perPage: 1000,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    items: []
  }),
  watch: {},
  created() {
    this.order_id = this.$route.query.o;
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    dataProvider(ctx, callback) {}
  }
};
</script>
